import React   , {useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import Box from "@mui/material/Box";
import PreviewButton from "../PreviewButton";
import { useDispatch, useSelector } from "react-redux"; 
import PaymentExpert from "./PaymentExpert";
import PaymentGarage from "./PaymentGarage"; 
import { getTask , completeTask } from "../../../store/action/taskAction"; 
import { filterPayment } from "../../../store/action/payment";
import {useNavigate} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        marginTop:'10px',
        borderRadius:'8px',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px", 
    },
    AffectedSection: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        justifyContent: "center"
    },
    uploadRectangle: {
        width: '100%',
        height: '374px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);'
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(187, 200, 8, 1)',
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    //popup:
    titre: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(63, 66, 84, 1)',
    },
    titreLabel: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    tablePagination: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        color: 'rgba(32, 18, 70, 1)'
    },
    dateRangeContainer: {
        display: 'flex',
        alignItems: 'center',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        padding: '5px 10px',
    },
    dateContainer: {
        border: 'none',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
    },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '148px',
        height: '29.69px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    dialogPaper: {
        width: '1300px',
        overflow: 'hidden',
        background: 'rgb(243, 246, 249)',
    },
    dialogTitle: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 18,
        color: 'rgba(63, 66, 84, 1)',
        backgroundColor: 'white',
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
    },

    dialogContent: {
        overflowY: 'auto',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    closeButton: {
        cursor: 'pointer',
        color: 'rgba(32, 18, 70, 1)',
        marginLeft: 1051,
    },
    //for the preview btn
    previewBtn:{
        position: 'absolute',
        background: 'rgb(243, 246, 249)',
        right: '20px',
    },

    
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

const PaymentParties = ({ taskId }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const username = localStorage.getItem('username');
    const [task, setTask] = useState({}); 
    const [paymentExpertData , setPaymentExpertData]= useState(null);
    const [actionExpertTask, setActionExpertTask]= useState(false);
    const [paymentGarageData , setPaymentGarageData]= useState(null);
    const [actionGarageTask, setActionGarageTask]= useState(false);
    const infoSinistre = task.businessKey
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const getPayment = async (claimNumber) => {
        try {
            const response = await filterPayment(claimNumber);
            const paymentExpert = response.filter(obj => obj.__t === "paymentInspector")[0];
            const paymentRepair = response.filter(obj => obj.__t === "paymentRepair")[0];
            setPaymentExpertData(paymentExpert);
            setPaymentGarageData(paymentRepair);
             
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };
   
    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username);
             
            setTask(response);
            getPayment(response.businessKey) 
            if(response.assignee === username){
                setIsTaskClaimed(false)
            }else {
                 setIsTaskClaimed(true)
            }
             
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };

    const ValidationAction = async () => {
        const validationErrors = [];
        if (paymentExpertData!=null && !actionExpertTask) {
            validationErrors.push("Veuillez Rejeter ou valider Honoraire Expert.");
            return;
          }
        if (paymentGarageData!=null && !actionGarageTask) {
            validationErrors.push("Veuillez Rejeter ou valider Honoraire Garage.");
            return;
        }
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }
        try {
          await dispatch(completeTask(taskId, username, {}));
          navigate('/todo-list', { reload: true });
        } catch (error) {
          console.error(error);
            validationErrors.push("Erreur lors de la validation. Veuillez réessayer.");
        }
      }
    useEffect(() => {
        fetchTask()
        if(task.assignee === username){
            setIsTaskClaimed(false)

        }else {
            setIsTaskClaimed(true)
        } 
    }, []);

    return (            
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
            <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>
             
            <Paper className={classes.paper}>
                {paymentExpertData && 
                    <div  className={classes.leftSection} >
                        <PaymentExpert isTaskClaimed={isTaskClaimed}  data={paymentExpertData} setAction={setActionExpertTask} actionPI  = {false}/>
                    </div>
                }
                {paymentGarageData && 
                    <div  className={classes.leftSection}>
                        <PaymentGarage   isTaskClaimed={isTaskClaimed} data={paymentGarageData} setAction ={setActionGarageTask} actionPI  = {false}/>
                    </div>
                } 
            </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
            </div>
            <ValidationButton  
                handleValidation={() =>isTaskClaimed? null : ValidationAction()} 
                />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default PaymentParties;
